import { createStore } from 'vuex'
import pageHeader from '@/store/modules/pageHeader.js'
export default createStore({
    modules: {
        pageHeader,
    }
})
